import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import { MatDialog } from '@angular/material';
import { SessionService } from '../../shared/services/session.service';
import { Yr3StStavaChapter6Component } from '../../yr3-studentweb/yr3-st-stava/yr3-st-stava-chapter6/yr3-st-stava-chapter6.component';
import { Yr3StOrdattforstaChapter6Component } from '../../yr3-studentweb/yr3-st-ordattforsta/yr3-st-ordattforsta-chapter6/yr3-st-ordattforsta-chapter6.component';
import { Yr3StMemorygameComponent } from '../../yr3-studentweb/yr3-st-memorygame/yr3-st-memorygame.component';
import { Yr3StBladderblocketComponent } from '../../yr3-studentweb/yr3-st-bladderblocket/yr3-st-bladderblocket.component';


@Component({
  selector: 'app-yr3-st-studenthome',
  templateUrl: './yr3-st-studenthome.component.html',
  styleUrls: ['./yr3-st-studenthome.component.scss']
})
export class Yr3StStudenthomeComponent implements OnInit {
  public bloburl: string;
  constructor(private sessionService: SessionService, public dialog: MatDialog) { this.bloburl = this.sessionService.bloburl; }
  ngOnInit() {    
    $(".rb_ch").hide();
    $(".wb_ch").hide();    
  }
  yr3_stava(i) {
    var comparr: any[string];
    comparr = [     
      Yr3StStavaChapter6Component    

    ];
    let dialogRef = this.dialog.open(comparr[i], {
      disableClose: true
    });
    this.yr3_Stava_off();
  }
  yr3_ordattforsta(i) {
    var comparr: any[string];
    comparr =
      [       
        Yr3StOrdattforstaChapter6Component      
      ];
    let dialogRef = this.dialog.open(comparr[i], {
      disableClose: true
    });
    this.yr3_ordattforsta_off();
  }

  yr3_Stava_on() {
    document.getElementById("yr3_stava_overlay").style.display = "block";
    document.getElementById("yr3_stava-imageTable").style.display = "block";
  }

  yr3_Stava_off() {
    document.getElementById("yr3_stava_overlay").style.display = "none";
    document.getElementById("yr3_stava-imageTable").style.display = "none";
  }
  yr3_ordattforsta_on() {
    document.getElementById("yr3_ordattforsta_overlay").style.display = "block";
    document.getElementById("yr3_ordattforsta-imageTable").style.display = "block";
  }

  yr3_ordattforsta_off() {
    document.getElementById("yr3_ordattforsta_overlay").style.display = "none";
    document.getElementById("yr3_ordattforsta-imageTable").style.display = "none";
  }
  yr3_puzzel_on() {
    document.getElementById("yr3st_puzzeloverlay").style.display = "block";
    document.getElementById("puzzelimageTable").style.display = "block";
  }
  yr3_alfabet_on() {
    document.getElementById("yr3st_alfabetoverlay").style.display = "block";
    document.getElementById("alfabetimageTable").style.display = "block";
  }

  yr3_alfabet_off() {
    document.getElementById("yr3st_alfabetoverlay").style.display = "none";
    document.getElementById("alfabetimageTable").style.display = "none";
  }
  yr3_puzzel_off() {
    document.getElementById("yr3st_puzzeloverlay").style.display = "none";
    document.getElementById("puzzelimageTable").style.display = "none";
  }
  openstbladderblocket() {
    this.dialog.open(Yr3StBladderblocketComponent, {
      disableClose: true
    });
  }
  
  openmemory() {
    this.dialog.open(Yr3StMemorygameComponent, {
      disableClose: true
    });
  }  

}
